import {AfterViewInit, ChangeDetectionStrategy, Component, HostBinding, inject, Input} from '@angular/core';
import {Block} from '@paperlessio/sdk/api/models';
import {BlocksComponent} from '@blocks/blocks.component';
import {NavigationService} from '@shared/submission-gizmo/navigation.service';
import {DataSetInputComponent} from '../data-set-input.component';

@Component({
  selector: 'pl-data-set-input-row',
  templateUrl: '../../../blocks.component.html',
  styleUrls: [
    '../../../blocks.component.scss',
    './data-set-input-row.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataSetInputRowComponent extends BlocksComponent implements AfterViewInit {
  @Input() block: Block;
  @Input() row_id?: string;

  private navigationService = inject(NavigationService, {optional: true});

  @HostBinding('id') get id() {
    return 'data-set-row-' + this.row_id;
  }

  get children() {
    return this.block.children;
  }

  dataSetInputComponent = inject(DataSetInputComponent);
  dataSetInputRowComponent = inject(DataSetInputRowComponent, {skipSelf: true, optional: true});

  get virtualSlug() {
    return [...this.dataSetInputRowComponent?.virtualSlug || [], this.dataSetInputComponent.block.slug, this.row_id];
  }

  ngAfterViewInit() {
    if (this.dataSetInputComponent.rowAdded === true) {
      this.dataSetInputComponent.rowAdded = false;

      setTimeout(() => {
        this.navigationService?.activateFirstTargetWithin(this.elementRef.nativeElement);
      }, 50);
    }
  }
}
